const toEnglishNumbers = (input) => {
  return input
    .replace(/[۰-۹]/g, (char) => String(char.charCodeAt(0) - 1776))
    .replace(/[٠-٩]/g, (char) => String(char.charCodeAt(0) - 1632));
};

export default toEnglishNumbers;
